module.exports = __webpack_public_path__ + "img/Realisme_Framveksten_av_en_moderne_verden1.54f88818.jpg";